import { render, staticRenderFns } from "./OneTimeDonate.vue?vue&type=template&id=ddb7f1ec&"
import script from "./OneTimeDonate.vue?vue&type=script&lang=js&"
export * from "./OneTimeDonate.vue?vue&type=script&lang=js&"
import style0 from "./OneTimeDonate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports